import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../../../graphql/types.generated';
const defaultOptions = {} as const;

export type AccountContactsQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
  connectionType?: GraphQLTypes.InputMaybe<
    Array<GraphQLTypes.AccountConnectionTypeEnum> | GraphQLTypes.AccountConnectionTypeEnum
  >;
  searchContains: GraphQLTypes.Scalars['String']['input'];
  withTerminals: GraphQLTypes.Scalars['Boolean']['input'];
  displayHeadquartersAtTop?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Boolean']['input']>;
  includeZencargo?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Boolean']['input']>;
}>;

export type AccountContactsQueryResult = { __typename?: 'Query' } & {
  searchAccountAndConnectionLocations?: GraphQLTypes.Maybe<
    { __typename?: 'AccountLocationConnection' } & {
      nodes: Array<
        GraphQLTypes.Maybe<
          { __typename?: 'AccountLocation' } & Pick<GraphQLTypes.AccountLocation, 'id'> & {
              label?: GraphQLTypes.Maybe<{ __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long'>>;
            }
        >
      >;
    }
  >;
  terminals?: GraphQLTypes.Maybe<
    { __typename?: 'TerminalConnection' } & {
      nodes?: GraphQLTypes.Maybe<
        Array<GraphQLTypes.Maybe<{ __typename?: 'Terminal' } & Pick<GraphQLTypes.Terminal, 'id' | 'label' | 'unlocode'>>>
      >;
    }
  >;
};

export const AccountContactsDocument = /*#__PURE__*/ gql`
  query accountContacts(
    $accountId: String!
    $connectionType: [AccountConnectionTypeEnum!]
    $searchContains: String!
    $withTerminals: Boolean!
    $displayHeadquartersAtTop: Boolean
    $includeZencargo: Boolean
  ) {
    searchAccountAndConnectionLocations(
      accountId: $accountId
      first: 50
      searchAccountAndConnectionLocationsFiltersInput: {
        accountIds: []
        connectionType: $connectionType
        displayHeadquartersAtTop: $displayHeadquartersAtTop
        searchQuery: $searchContains
        includeZencargo: $includeZencargo
      }
    ) {
      nodes {
        id
        label {
          long
        }
      }
    }
    terminals(query: $searchContains) @include(if: $withTerminals) {
      nodes {
        id
        label
        unlocode
      }
    }
  }
`;

/**
 * __useAccountContactsQuery__
 *
 * To run a query within a React component, call `useAccountContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountContactsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      connectionType: // value for 'connectionType'
 *      searchContains: // value for 'searchContains'
 *      withTerminals: // value for 'withTerminals'
 *      displayHeadquartersAtTop: // value for 'displayHeadquartersAtTop'
 *      includeZencargo: // value for 'includeZencargo'
 *   },
 * });
 */
export function useAccountContactsQuery(
  baseOptions: Apollo.QueryHookOptions<AccountContactsQueryResult, AccountContactsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<AccountContactsQueryResult, AccountContactsQueryVariables>(AccountContactsDocument, options);
}
export function useAccountContactsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AccountContactsQueryResult, AccountContactsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<AccountContactsQueryResult, AccountContactsQueryVariables>(AccountContactsDocument, options);
}
export type AccountContactsQueryHookResult = ReturnType<typeof useAccountContactsQuery>;
export type AccountContactsLazyQueryHookResult = ReturnType<typeof useAccountContactsLazyQuery>;
